import axios from "./configAxios";

export const getGroupApi = async(group_id) => {
    return await axios.get(`/${group_id}/`)
}